<template>
  <div v-loading="isLoading" class="my-wallet">
    <div class="my-wallet-title">
      <el-dropdown v-if="!isNotData" class="wallet-drop" :teleported="false" placement="bottom-end" trigger="click">
        <div class="switch-card">
          <img src="../imgs/swtich-card.png" alt="">
          切换卡片
        </div>
        <template #dropdown>
          <el-dropdown-menu class="max-h-[322px]">
            <template
              v-for="(v, idx) in wallets" 
              :key="idx"
            >
              <el-dropdown-item
                @click="dateMode = idx"
              >
                <img :src="getCurrentLogo(v)" alt="">
                <div class="account">
                  <div class="name">
                    <template v-if="v.payType === EPaymentChannel.ZS || v.payType === EPaymentChannel.AlipayAccountBook">
                      <img src="@core/main/assets/images/server-ico.png" alt="">
                    </template>
                    <template v-else>
                      <template v-if="isAgent">
                        <img src="@core/main/assets/images/agent-ico.png" alt="">
                      </template>
                      <template v-if="isCompany">
                        <img src="@core/main/assets/images/company-ico.png" alt="">
                      </template>
                      <template v-if="isServer">
                        <img src="@core/main/assets/images/server-ico.png" alt="">
                      </template>
                    </template>
                    <div class="label">
                      {{ v.payType === EPaymentChannel.ZS || v.payType === EPaymentChannel.AlipayAccountBook
                        ? isNull(v.serverName) ? '--' : v.serverName 
                        : v.payType === EPaymentChannel.Yibao
                          ? isNull(v.yopMerchantInfo?.name) ? '--' : v.yopMerchantInfo?.name
                          : v.payType === EPaymentChannel.LianlianBill && !!v.airbillCompanyLianInfo
                            ? isNull(v.airbillCompanyLianInfo?.name) ? '--' : v.airbillCompanyLianInfo?.name
                            : v.payType === EPaymentChannel.LianlianBill && !!v.airbillAgentLianInfo
                              ? isNull(v.airbillAgentLianInfo?.name) ? '--' : v.airbillAgentLianInfo?.name
                              : isNull(v.bizName) ? '--' : v.bizName }}
                    </div>
                  </div>
                  <div class="number">
                    {{ v.payType === EPaymentChannel.Yibao
                      ? isNull(v?.yopMerchantInfo?.merchantNo) ? '--' : v?.yopMerchantInfo?.merchantNo 
                      : v.payType === EPaymentChannel.LianlianBill && !!v.airbillAgentLianInfo 
                        ? isNull(v?.airbillAgentLianInfo?.lianNo) ? '--' : v?.airbillAgentLianInfo?.lianNo 
                        : v.payType === EPaymentChannel.LianlianBill && !!v.airbillCompanyLianInfo 
                          ? isNull(v?.airbillCompanyLianInfo?.lianNo) ? '--' : v?.airbillCompanyLianInfo?.lianNo 
                          :isNull(v.accountNo) ? '--' : v.accountNo }}
                  </div>
                </div>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>

    <!-- 连连 -->
    <lian-wallet v-if="currentWallet?.payType === EPaymentChannel.Lianlian" @reload="fetchData" />

    <!-- 招商 -->
    <zs-wallet v-if="currentWallet?.payType === EPaymentChannel.ZS" @reload="fetchData" />

    <!-- 支付宝 -->
    <alipay v-if="currentWallet?.payType === EPaymentChannel.Alipay" @reload="fetchData" />

    <!-- 支付宝(记账簿) -->
    <alipay-book v-if="currentWallet?.payType === EPaymentChannel.AlipayAccountBook && isCompany" @reload="fetchData" />

    <!-- 易宝 -->
    <yibao v-if="currentWallet?.payType === EPaymentChannel.Yibao && !isServer" :company="isCompany" @reload="fetchData" />

    <!-- 连连(分账) -->
    <bill-lianlian-wallet v-if="currentWallet?.payType === EPaymentChannel.LianlianBill && !isServer" :company="isCompany" @reload="fetchData" />
    
    <div v-if="isNotData" class="mt-[84px]">
      <not-data-wallet />
    </div>
  </div>
</template>

<script setup lang="ts">
import LianWallet from '../widgets/LianLianWallet.vue';
import ZsWallet from '../widgets/ZsWallet.vue';
import Alipay from '../widgets/AliPay.vue';
import AlipayBook from '../widgets/AliPayBook.vue';
import Yibao from '../widgets/Yibao.vue';
import BillLianlianWallet from '../widgets/BillLianlianWallet.vue';
import NotDataWallet from '../widgets/NotDataWallet.vue';
import { computed, inject, provide, ref } from 'vue';
import useUserStore from '@core/main/src/stores/user';
import { ElMessage } from 'element-plus';
import { EPaymentChannel, ISecuritySettingDetail } from '@core/main/types/common';
import { queryFinanceWallets, querySecuritySettingDetail } from '@core/main/api';
import { IFinanceWallet } from '@core/main/types/finance';
import { isNull } from '@core/tools';
import { ESystemType } from '@core/api';
const { state: userState } = useUserStore();

const term = inject<'server' | 'company' | 'agent'>('term');

const dateMode = ref(0);
const loading = ref(false);
const infoLoading = ref(false);
const wallets = ref<IFinanceWallet[]>([]);
const payInfo = ref<ISecuritySettingDetail>();

const companyId = computed(() => userState.identity?.companyId);
const agentId = computed(() => userState.identity?.agentId);
const serverId = computed(() => userState.identity?.serverId);
const systemType = computed(() => userState.identity?.systemType);
const isCompany = computed(() => systemType.value === ESystemType.Company);
const isAgent = computed(() => systemType.value === ESystemType.Agent);
const isServer = computed(() => systemType.value === ESystemType.Server);
const id = computed(() => term === 'server' ? serverId.value : term === 'agent' ? agentId.value : companyId.value);
const currentWallet = computed(() => wallets.value[dateMode.value] as IFinanceWallet);
const isLoading = computed(() => loading.value || infoLoading.value);
const isNotData = computed(() => wallets.value?.length === 0);

function getCurrentLogo(v: IFinanceWallet) {
  return v.payType === EPaymentChannel.ZS 
    ? new URL('../imgs/swtich-wallet/zs.png', import.meta.url).href 
    : v.payType === EPaymentChannel.Alipay
      ? new URL('../imgs/swtich-wallet/zfb.png', import.meta.url).href 
      : v.payType === EPaymentChannel.AlipayAccountBook
        ? new URL('../imgs/swtich-wallet/jzp.png', import.meta.url).href
        : v.payType === EPaymentChannel.Lianlian || v.payType === EPaymentChannel.LianlianBill
          ? new URL('../imgs/swtich-wallet/lianlian.png', import.meta.url).href 
          : new URL('../imgs/swtich-wallet/yb.png', import.meta.url).href;
}

async function fetchPayInfo() {
  infoLoading.value = true;
  try {
    const res = await querySecuritySettingDetail(id.value, systemType.value);

    payInfo.value = res as ISecuritySettingDetail;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  infoLoading.value = false;
}

async function fetchData() {
  loading.value = true;

  try {
    wallets.value = await queryFinanceWallets(true);
  } catch (error) {
    if (error instanceof Error) ElMessage.error(error.message);
  }

  loading.value = false;
}

function init() {
  fetchPayInfo();
  fetchData();
}

init();

provide('payInfo', payInfo);
provide('data', currentWallet);
</script>

<style lang="scss" scoped src="../style/my-wallet.scss" />
